/**
 * 功能描述：上传文件常量定义 <br>
 * 〈〉
 * @Author CHU
 * @Date 15:28 2021/2/19
 * @Version 1.0.0
 **/

// 允许上传的文件类型
export const ALLOW_UPLOAD_FILE_TYPE =
  ".doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx";

export const UPLOAD_WARNING_MESSAGE = "文件上传错误";
